import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from './AuthContext';

/** Redirects new users to onboarding once per account. */
export default function OnboardingGate({ children }) {
  const { apiClient, isAuthenticated } = useContext(AuthContext);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!isAuthenticated) {
      setStatus('ready');
      return;
    }
    if (localStorage.getItem('qnaread.onboardingDone') === '1') {
      setStatus('ready');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await apiClient.get('/api/users/me/learning-profile');
        if (cancelled) return;
        if (res.data?.onboardingCompleted) {
          localStorage.setItem('qnaread.onboardingDone', '1');
          setStatus('ready');
        } else {
          setStatus('onboarding');
        }
      } catch {
        if (!cancelled) setStatus('ready');
      }
    })();
    return () => { cancelled = true; };
  }, [apiClient, isAuthenticated]);

  if (status === 'loading') {
    return <div className="loading-spinner" aria-label="Loading" />;
  }
  if (status === 'onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
